import React from 'react';
import PropTypes from 'prop-types';
import { BackboneInstanceWrapper } from '@bingads-webui-react/backbone-instance-wrapper';
import { INLINE_CHART_TOGGLE_BUTTON_ID } from '../../constant';

export default class ProductGroupInlineChartWrapper extends React.Component {
  static propTypes = {
    deps: PropTypes.objectOf(PropTypes.any).isRequired,
    upperToolbar: PropTypes.objectOf(PropTypes.any).isRequired,
    hasFilter: PropTypes.bool.isRequired,
  }

  constructor(props) {
    super(props);
    this.chartView = new this.props.deps.InlineChartView({
      filter: {},
      entityType: this.props.deps.inlineChartConstants.AdEdmEntity,
      isUsingVnextGrid: true,
      hideChartToolbar: true,
    });

    if (window.App && window.App.views && window.App.views.Summary) {
      window.App.views.Summary.bindDateFilterChangeHandler(() => {
        /* eslint-disable no-underscore-dangle */
        this.chartView._onGridPageLoadingNewGrid({});
      });
    }
  }

  updateToggleButtonOnToolbar = () => {
    if (this.props.hasFilter) {
      this.props.upperToolbar.view.update({
        type: 'button',
        id: INLINE_CHART_TOGGLE_BUTTON_ID,
        classes: ['btn', 'chart-icon', 'disabled'],
        onClick: () => {},
      });
    } else {
      this.props.upperToolbar.view.update({
        type: 'button',
        id: INLINE_CHART_TOGGLE_BUTTON_ID,
        classes: ['btn', 'chart-icon'],
        onClick: () => {
          this.chartView.inlineChartViewModel.onShowChartButtonClick();
        },
      });
    }
  }

  render() {
    this.updateToggleButtonOnToolbar();
    return this.props.hasFilter ?
      null : <BackboneInstanceWrapper instance={this.chartView} managed />;
  }
}
